import {navigation} from './navigation.directive';
import {NavigationController} from './navigationController';
import {NavigationPagesService} from './navigationPages.service';
import './toolbar/bootstrap';
import './sidenav/bootstrap';
import './navigationService';

let appModule = angular.module('deliveryCreate.app');

appModule.directive('navigation', navigation);
appModule.controller('NavigationController', NavigationController);
appModule.service('NavigationPagesService', NavigationPagesService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/bootstrap.ts
 **/